import { render, staticRenderFns } from "./AddShift.vue?vue&type=template&id=2ba21b9e&scoped=true"
import script from "./AddShift.vue?vue&type=script&lang=ts"
export * from "./AddShift.vue?vue&type=script&lang=ts"
import style0 from "./AddShift.vue?vue&type=style&index=0&id=2ba21b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba21b9e",
  null
  
)

export default component.exports